import { Aviso } from "../ui";
import { useAvisoDeSucessoDaChegada } from "../../nucleo/voltarParaHome";

/** O aviso de sucesso de quem acabou de salvar um formulário e caiu na home. Aparece uma vez. */
export function AvisoDeSucessoDaChegada() {
  const aviso = useAvisoDeSucessoDaChegada();
  if (aviso === null) return null;
  return (
    <Aviso tom="sucesso" className="mb-4" data-testid="aviso-de-sucesso-da-chegada">
      <span role="status">{aviso}</span>
    </Aviso>
  );
}
